// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';
import { DioramaHeaderLayout } from '../dioramas/DioramaHeaderLayout';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'df0a19ab-0da4-45b0-ae5e-99737b81192e',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f71d59a4-2605-4c9a-8e4f-4998414477da',
      type: 'Container',
      name: 'dioramaSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'df0a19ab-0da4-45b0-ae5e-99737b81192e'
    },
    {
      id: '452790e0-c455-4c57-b475-fa514954f602',
      type: 'Layout',
      name: 'ribbon',
      className: '',
      path: 'dioramas/DioramaHeaderLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -400,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'df0a19ab-0da4-45b0-ae5e-99737b81192e'
    },
    {
      id: '9b854691-6354-49ce-8ad3-a3539cd9ec13',
      type: 'Layout',
      name: 'fillButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'df0a19ab-0da4-45b0-ae5e-99737b81192e',
      data: {
        color: 'grey',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'cf5682d4-be92-4c6b-9289-5894e0526f14',
      type: 'NineSlicePlane',
      name: 'greenFill',
      className: '',
      x: -170,
      y: -55,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 340,
      height: 110,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Green',
      parent: '9b854691-6354-49ce-8ad3-a3539cd9ec13'
    },
    {
      id: '7662b66c-26eb-457b-bf4e-bbb22c7a882e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -150,
      y: -42,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.292969,
        y: 0.292969
      },
      angle: 0,
      alpha: 0.2,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: '9b854691-6354-49ce-8ad3-a3539cd9ec13'
    },
    {
      id: 'c70175a0-2f39-4b6a-bff5-acc41cf0aa7b',
      type: 'Sprite',
      name: 'tileIcon',
      className: '',
      x: -113,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon',
      parent: '9b854691-6354-49ce-8ad3-a3539cd9ec13'
    },
    {
      id: '9123f471-a20a-46a7-bcec-ff06c68d7396',
      type: 'Text',
      name: '',
      className: '',
      x: 37,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hold to fill',
      localize: true,
      maxWidth: 229,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9b854691-6354-49ce-8ad3-a3539cd9ec13'
    },
    {
      id: '6b86a567-d645-432d-bbdb-78d711ea6632',
      type: 'Text',
      name: 'tileAmount',
      className: '',
      x: -113,
      y: 16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '200',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9b854691-6354-49ce-8ad3-a3539cd9ec13'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1000,
  version: '1.0.0',
  handleResize: false
} as const;

export class DioramaFillPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  dioramaSlot!: Container;
  ribbon!: DioramaHeaderLayout;
  fillButton!: ButtonLargeLayout & { data: typeof raw['list'][4]['data'] };
  greenFill!: NineSlicePlane;
  tileIcon!: Sprite;
  tileAmount!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
